import { permission } from './permission';
import { add } from './add';
import { remove } from './delete';
import { all, single } from './read';
import { logout } from './logout';

const user: Record<string, any> = {
  permission,
  all,
  single,
  add,
  remove,
  logout,
};
export default user;
